/**
 * Datas de previsão da OS (data_previsao_inicio / data_previsao_termino).
 *
 * A API de OS guarda a previsão como horário de parede (wall-clock, sem
 * timezone) e a devolve com sufixo "Z" (ex: "2026-10-16T13:56:00.000000Z").
 * Esse "Z" NÃO significa UTC convertido: 13:56 digitado deve continuar 13:56.
 *
 * Por isso NÃO podemos usar `new Date(valor)` aqui: o browser interpretaria
 * o "Z" como UTC e converteria para o fuso local (BRT = -3h), exibindo 10:56
 * e, se salvar, gravando 10:56 no banco. Cada ciclo abrir+salvar perdia 3h.
 *
 * Estes helpers tratam a string como texto, sem conversão de timezone.
 * Para instantes reais (data_hora, data_alterada, logs, etc.) continue usando
 * `new Date` + Intl, que está correto.
 */

// "2026-10-16T13:56:00.000000Z" -> "2026-10-16T13:56"
// "2026-10-16 13:56:00" -> "2026-10-16T13:56"
// "2026-10-16T13:56" -> "2026-10-16T13:56"
export const osDateTimeInput = value => {
  if (!value) return "";

  const text = String(value).trim();
  if (!text) return "";

  const normalized = text.replace(" ", "T");
  const match = normalized.match(
    /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/
  );

  if (!match) return "";

  const year = match[1];
  const month = match[2];
  const day = match[3];
  const hour = match[4];
  const minute = match[5];

  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// "2026-10-16T13:56:00.000000Z" -> "16/10/2026, 13:56"
export const formatOsPrevisao = value => {
  if (!value) return "-";

  const text = String(value).trim();
  if (!text) return "-";

  const normalized = text.replace(" ", "T");
  const match = normalized.match(
    /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/
  );

  if (!match) return "-";

  const year = match[1];
  const month = match[2];
  const day = match[3];
  const hour = match[4];
  const minute = match[5];

  return `${day}/${month}/${year}, ${hour}:${minute}`;
};
